import { useTranslation } from 'react-i18next';
import Table from 'components/Table/Table';
import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableHead from 'components/Table/TableHead';
import TableRow from 'components/Table/TableRow';
import { getTextDate } from 'utils/formattedData';

import type IVCTable from '../interfaces/IVCTable';

import styles from '../sass/VCTable.module.scss';

function VCTable({ items, headCells }: IVCTable) {
  const { t } = useTranslation();
  const hyphen = t('common.hyphen');

  return (
    <Table
      className={styles.table}
    >
      <TableHead className={styles.header}>
        {headCells.map(({
          id, label,
        }) => (
          <TableCell head className={styles.tableCell} key={id}>
            <div>
              <span className={styles.tableCellLabel}>
                {t(label)}
              </span>
            </div>
          </TableCell>
        ))}
      </TableHead>
      <TableBody>
        {items ? items?.map((item, index) => (
          <TableRow key={[item.id, index].join('_')}>
            <TableCell className={styles.tableCell}>
              <div className={styles.name}>
                {item.name}
              </div>
            </TableCell>
            <TableCell className={styles.tableCell}>
              <div className={`${styles.roleCell} ${styles.updatedBy}`}>
                <span>
                  {item.createdAt
                    ? getTextDate(item.createdAt)
                    : hyphen}
                </span>
                <span>
                  by
                  {' '}
                  {item.createdBy
                    ? `${item.createdBy.firstName} ${item.createdBy.lastName}`
                    : hyphen}
                </span>
              </div>
            </TableCell>
            <TableCell className={styles.tableCell}>
              <div className={`${styles.roleCell} ${styles.updatedBy}`}>
                <span>
                  {item.updatedAt
                    ? getTextDate(item.updatedAt)
                    : hyphen}
                </span>
                <span>
                  by
                  {' '}
                  {item.updatedBy
                    ? `${item.updatedBy.firstName} ${item.updatedBy.lastName}`
                    : hyphen}
                </span>
              </div>
            </TableCell>
          </TableRow>
        )) : null}
      </TableBody>
    </Table>
  );
}

export default VCTable;
